<!-- <div class="select" *ngIf="model" [class]="model.cssClassSelect">
<div class="select-choice" [class.disabled]="model.disabled" (click)="onClickSelect()">
  <ng-container *ngIf="model.selected.value; else NA">{{model.selected.value}}</ng-container>


</div>
<ol class="select-wrap-option" *ngIf="model.opened">
  <li class="select-option" *ngFor="let option of model.options" (click)="onSelectedOption(option)">{{option.value}}</li>
</ol>
</div>

<ng-template #NA>{{coreEnum.TEXT_NA}}</ng-template> -->

<select title="" name="" id="select" class="form-control" [(ngModel)]="model.selected.key" [ngModelOptions]="{ standalone: true }" [class.disabled]="model.disabled" (click)="onClickSelect()">
  @for (option of model.options; track option) {
    <option [selected]="model.selected.value == option.value" [ngValue]="option.key" (click)="onSelectedOption(option)">
      {{option.value}}
    </option>
  }
</select>
